import { Input } from "antd";
import React, { useState } from "react";

const SearchComponent = ({
  placeholder,
  filters,
  setFilters,
  entity,
  style = null,
}) => {
  const [query, setQuery] = useState("");
  const handleInputEnter = () => {
    setFilters({ ...filters, [`${entity}`]: query });
    setQuery("");
  };
  const handleInputChange = (value) => {
    setQuery(value.target.value);
  };
  return (
    <div style={style ? style : { width: "100%" }}>
      <p style={{ fontSize: "16px" }}>Search:</p>
      <Input
        placeholder={placeholder}
        style={{ height: "40px", width: "60%", marginTop: "5px" }}
        onChange={handleInputChange}
        onPressEnter={handleInputEnter}
      />
    </div>
  );
};

export default SearchComponent;
